// extracted by mini-css-extract-plugin
module.exports = {"definition-list":"definition-list_definition-list__22tK8","no-background":"definition-list_no-background__2045C","emphasis":"definition-list_emphasis__3BSy_"};